<template>
  <div class="video_tutorial">
    <Menu v-if="$route.query.p !== 'app'" />
    <div class="vt_box">
      <h1 class="vt_title">视频教程</h1>
      <div class="vt_list">
        <div
          class="item"
          v-for="(item, index) in videos"
          :key="index"
          @click="playVideo(index)"
        >
          <video
            :ref="`video${index}`"
            preload="auto"
            playsinline
            playsinlinex5-video-player-type="h5"
            x5-video-player-fullscreen="true"
            x5-playsinline="true"
            x-webkit-airplay="allow"
            x5-video-orientation="landscape|portrait"
            style="object-fit: fill"
            webkit-playsinline="true"
            x5-video-player-type="h5-page"
            @play="handleFullScreen"
            @ended="handleExitFullScreen"
            :src="item.url"
          ></video>
          <div class="vtitle">
            <p>{{ item.name }}</p>
          </div>
          <img class="play_icon" src="@/assets/helpcenter/play@2x.png" alt="" />
        </div>
      </div>
    </div>
    <videosH :url="video_bx_url" v-show="showVb" @hide="hideVideoBx" />
    <Footer />
  </div>
</template>
<script>
import Menu from "@/components/menu";
import Footer from "@/components/footer";
import videosH from "@/components/videosH";
export default {
  components: {
    Menu,
    Footer,
    videosH,
  },
  data() {
    return {
      videos: [],
      video_bx_url: "",
      showVb: false,
    };
  },
  async created() {
    let res2 = await this.$serve.getVideoList();
    this.videos = res2.data.list;
  },
  methods: {
    handleFullScreen(e) {
      //开始播放
    },
    handleExitFullScreen(e) {
      //播放结束
      e.target.controls = false;
    },
    playVideo(index) {
      this.video_bx_url = this.videos[index].url;
      this.showVb = true;
    },
    hideVideoBx() {
      this.showVb = false;
    },
  },
};
</script>
<style lang="less" scoped>
.video_tutorial {
  padding-top: 10px;
  background: #fff;
  .vt_box {
    margin: auto;
    padding-bottom: 50px;
    .vt_title {
      text-align: center;
      font-size: 26px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #1e232a;
      margin-bottom: 34px;
    }
    .vt_list {
      display: flex;
      flex-flow: row wrap;
      // justify-content: center;
      padding-left: 20px;
      .item {
        margin-bottom: 10px;
        width: 158px;
        background: #ffffff;
        box-shadow: 0px 0px 9px 0px rgba(0, 0, 0, 0.14);
        border-radius: 4px;
        margin-left: 5px;
        margin-right: 5px;
        position: relative;
        .play_icon {
          position: absolute;
          right: 0;
          display: block;
          top: 0;
          width: 50px;
          height: 50px;
        }
        video {
          width: 100%;
          height: 80px;
          object-fit: fill;
        }
        .vtitle {
          height: 44px;
          padding: 6px 12px;
          display: flex;
          box-sizing: border-box;
          align-items: center;
          p {
            font-size: 13px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #131314;
            line-height: 18px;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 100%;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            word-break: break-all;
          }
        }
      }
    }
  }
}
</style>
